<template>
  <dir>
    <div
      v-if="inject && !hideHint"
      class="mb-1"
    >
      <div style="width: 400px;">
        <v-tabs
          v-model="injectTransport"
          color="transparent"
          active-class="blue--text"
          centered
          height="40"
        >
          <v-tabs-slider color="blue" />
          <v-tab
            href="#se"
          >
            <SrIcon
              :transport="'se'"
              class="mr-2"
              small
            />
            海快
          </v-tab>
          <v-tab
            href="#air"
          >
            <SrIcon
              :transport="'air'"
              class="mr-2"
              small
            />
            空運
          </v-tab>
          <v-tab
            href="#sea"
          >
            <SrIcon
              :transport="'sea'"
              class="mr-2"
              small
            />
            海運
          </v-tab>
        </v-tabs>

        <SeFee
          v-if="injectTransport==='se'"
          inject
        />
        <AirFee
          v-else-if="injectTransport==='air'"
          inject
        />
        <SeaFee
          v-else-if="injectTransport==='sea'"
          inject
        />
      </div>
      <br>
      低消：空運1公斤起運，未滿1公斤以1公斤計費。<br>海快起運重量各倉庫不同，請查看「倉庫」介紹確認，未滿低消以低消計費。<br>
      <br>
      ＊總重低於5kg的訂單採用包頻繁稅固定+50元，全包稅固定+75元，5kg以上訂單包稅方式不變。<br>
      <br>
      ＊各倉庫免費包裹可單獨0kg集運，僅需支付派件費：自取店自取0元、7-11取貨60元、黑貓宅配90元、新竹宅配100元。（免費包裹可打包數量及物流方式以各倉庫提供的服務為準。）<br>
      <br>
      運費均已包含派送費、清關費。<br>
      <br>
      以下狀況不包稅：<br>
      1、X2不包稅、X3簡易報關、G1正式報關。<br>
      2、海關要求轉正式報關。<br>
      3、【X2包頻繁稅】被海關C3查驗要求申報繳稅的情況。<br>
      <br>
      ＊個別商品有進口限制，請登入網站使用【能寄嗎？】查詢<br>
      另外，空運有收取拋貨費（體積費用），海快沒有收取拋貨費（體積費用）。<br>
      您可以使用「運費試算」工具，預估商品會產生的費用及運費，謝謝^^<br>
    </div>
    <div
      :style="{width: `${width}px`}"
      :class="{inject: inject}"
    >
      <div
        :class="{ 'grey lighten-5': !$vuetify.theme.dark, dark: $vuetify.theme.dark }"
      >
        <v-card
          flat
        >
          <v-divider v-if="!inject" />
          <v-layout
            class="inputWrapTr ma-0"
            align-stretch
          >
            <div class="text-center">
              <span
                class="red--text"
                style="display: inline-block;width: 10px"
              />包裹體積
            </div>
            <v-layout
              align-center
              class="ma-0"
            >
              <input
                v-model="form.length"
                placeholder="長"
              >
              <input
                v-model="form.width"
                placeholder="寬"
              >
              <input
                v-model="form.height"
                placeholder="高"
              >
              <div>
                /CM
              </div>
            </v-layout>
          </v-layout>
          <v-divider />
          <v-layout
            class="inputWrapTr"
            align-stretch
          >
            <div class="text-center">
              <span
                class="red--text"
                style="display: inline-block;width: 10px"
              >*</span>包裹重量
            </div>
            <v-layout
              align-center
              class="ma-0"
            >
              <input
                v-model="form.weight"
                placeholder="重量"
              >
              <div>
                /KG
              </div>
              <v-spacer />
            </v-layout>
          </v-layout>
          <v-divider />
          <v-layout
            class="pa-2"
            align-center
          >
            <v-checkbox
              v-model="isCalcWoodenFee"
              class="mt-0 pt-0"
              hide-details
            >
              <div
                slot="label"
                style="font-size: 14px;"
              >
                計算打木架/木箱費用
              </div>
            </v-checkbox>
            <v-spacer />
            <v-btn
              small
              round
              color="info"
              @click="startCalc"
            >
              預估運費
            </v-btn>
          </v-layout>
          <v-divider />
          <div
            v-if="calcForm.weight > 0"
            class="py-4 px-2"
          >
            <div
              v-for="(srItem,i) in srTypeList"
              :key="srItem.srid"
            >
              <v-layout>
                <div class="mx-2">
                  <SrIcon
                    :transport="srItem.transport"
                  />
                </div>
                <div class="ml-2">
                  <template v-if="srItem.transport === 'air' ">
                    <v-layout
                      v-if="calcForm.volWeight > calcForm.weight"
                      class="mb-2"
                    >
                      <div>體積重量：</div>
                      <div>
                        <b>{{ calcForm.volWeight | toKg }}KG</b>
                        <div class="caption grey--text">
                          （{{ calcForm.length }}*{{ calcForm.width }}*{{ calcForm.height }}/6000={{ calcForm.volWeight | toKg }}KG）
                        </div>
                      </div>
                    </v-layout>
                    <v-layout>
                      <div style="word-break: keep-all;">
                        計費重量：
                      </div>
                      <div>
                        <b>{{ computerSettlementWeight(calcForm.chgWeight,srItem.minWeight, true, srItem.transport) | toKg }}KG</b>
                        <span class="ml-2">普/特貨同價</span>

                        <div
                          v-if="calcForm.volWeight > calcForm.weight"
                          class="caption grey--text"
                        >
                          （{{ calcForm.volWeight | toKg }}-優惠{{ calcForm.volWeight-calcForm.chgWeight | toKg }}={{ calcForm.chgWeight | toKg }}KG）
                        </div>
                      </div>
                    </v-layout>
                  </template>
                  <v-layout v-else>
                    <div style="word-break: keep-all;">
                      計費重量：
                    </div>
                    <div>
                      <b>{{ computerSettlementWeight(calcForm.weight,srItem.minWeight, true, srItem.transport) | toKg }}KG</b>
                      <div class="caption grey--text">
                        （不足{{ srItem.minWeight | toKg }}KG按{{ srItem.minWeight | toKg }}KG計重）
                      </div>
                    </div>
                  </v-layout>
                </div>
              </v-layout>
              <v-divider
                v-if="i < srTypeList.length-1"
                class="my-4"
              />
            </div>
          </div>
        </v-card>

        <v-card
          v-if="calcForm.weight > 0"
          flat
          class="mt-2 pa-2"
        >
          <div class="subTitle mb-2">
            預估費用
          </div>
          <div class="py-4">
            <div
              v-for="(srItem,i) in srList"
              :key="srItem.srid"
            >
              <v-layout>
                <div class="mx-2 mt-1">
                  <SrIcon
                    :transport="srItem.transport"
                  />
                </div>
                <CalcFee
                  :srItem="srItem"
                  :chgWeight="srItem.transport==='air' ? calcForm.chgWeight : calcForm.weight"
                  class="ml-2"
                />
              </v-layout>
              <v-divider
                v-if="i < srList.length-1"
                class="my-4"
              />
            </div>
          </div>
        </v-card>
        <v-card
          v-if="hctCaiFee && srItem.transport !== 'sea'"
          flat
          class="mt-2 pa-2"
        >
          <div class="subTitle mb-2">
            新竹超才費
            <Tooltips>
              <HctCaiFeeText :transport="'se'" />
            </Tooltips>
          </div>
          <div class="py-2 pl-2">
            <b class="red--text headline mr-1">{{ hctCaiFee }}</b>元<br>
          </div>
        </v-card>
        <v-card
          v-if="calcForm.weight > 0 && isCalcWoodenFee && woodenFee[0]"
          flat
          class="mt-2 pa-2"
        >
          <div class="subTitle mb-2">
            打木架/木箱費用
          </div>
          <div class="py-2 pl-2">
            打木架： <b class="red--text headline mr-1">{{ woodenFee[0] }}</b>元<br>
            打木箱： <b class="red--text headline mr-1">{{ woodenFee[1] }}</b>元<br>
          </div>
        </v-card>
        <template
          v-if="calcForm.weight > 0"
        >
          <v-card
            v-if="calcForm.weight > 0"
            flat
            class="mt-2 pa-2"
          >
            <div class="subTitle mb-2">
              支持派件方式
              <v-menu
                offset-y
              >
                <template #activator="{ on }">
                  <v-btn
                    flat
                    icon
                    small
                    color="info lighten-2"
                    class="ma-0"
                    v-on="on"
                  >
                    <v-icon small>
                      help
                    </v-icon>
                  </v-btn>
                </template>
                <div>
                  <v-card class="light-blue lighten-5">
                    <v-card-text>
                      <div>
                        <div>
                          <b>支持派件方式</b>
                        </div>
                        <div>
                          超商<br>
                          1. 長+寬+高≦105公分<br>
                          2. 單邊長≦45公分、其他兩邊≦30公分<br>
                          3. 重量10公斤以內<br>
                        </div>
                        <div class="mt-2">
                          黑貓<br>
                          尺寸在120公分以下（長+寬+高三邊合計），20公斤以內。
                        </div>
                        <div class="mt-2">
                          新竹<br>
                          無限制
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
              </v-menu>
            </div>
            <div class="py-2 pl-2  caption">
              <v-layout
                :class="{limit:volumeLimitCs(limitCalcItem)||weightLimitCs(limitCalcItem)}"
                class="carrierItem py-2 px-2 ma-0"
                align-center
              >
                <img
                  src="/static/images/carrier/711.png"
                  width="16"
                  class="mr-1"
                >
                <div>
                  超商
                </div>
                <v-flex class="text-xs-center detailText">
                  <div v-if="volumeLimitCs(limitCalcItem)">
                    體積過超商限制(45cm*30cm*30cm)
                  </div>
                  <div v-if="weightLimitCs(limitCalcItem)">
                    重量超過超商限制(10kg)
                  </div>
                  <div class="canUse">
                    可使用
                  </div>
                </v-flex>
              </v-layout>
              <v-layout
                :class="{limit:volumeLimitTcat(limitCalcItem)||weightLimitTcat(limitCalcItem)}"
                class="carrierItem py-2 px-2 mt-2 ma-0"
                align-center
              >
                <img
                  src="/static/images/carrier/tcat.png"
                  width="18"
                  class="mr-1"
                >
                <div>
                  黑貓
                </div>
                <v-flex class="text-xs-center detailText">
                  <div v-if="volumeLimitTcat(limitCalcItem)">
                    體積過黑貓限制(長+寬+高≤120公分)
                  </div>
                  <div v-if="weightLimitTcat(limitCalcItem)">
                    重量超過黑貓限制(20kg)
                  </div>
                  <div class="canUse">
                    可使用
                  </div>
                </v-flex>
              </v-layout>
              <v-layout
                :class="{limit:limitHct(limitCalcItem, transport)}"
                class="carrierItem py-2 px-2 mt-2 ma-0"
                align-center
              >
                <img
                  src="/static/images/carrier/hct.png"
                  width="16"
                  class="mr-1"
                >
                <div>
                  新竹
                </div>
                <v-flex class="text-xs-center detailText">
                  <div v-if="limitHct(limitCalcItem, transport)">
                    超過新竹物流限制
                  </div>
                  <div class="canUse">
                    可使用
                  </div>
                </v-flex>
              </v-layout>
            </div>
          </v-card>
          <template v-if="srItem.transport !== 'sea'">
            <v-card
              v-if="hctHatPalletFee(limitCalcItem)"
              class="ma-2 pa-2"
            >
              <HctHatPalletFeeText />
            </v-card>

            <v-card
              v-if="volumeLimitAir(limitCalcItem) || airVolumeG1(limitCalcItem)"
              class="red--text ma-2 pa-2"
            >
              物品單邊長度不可超過160cm，空運三邊若兩邊超過 70cm 和 85cm 需要轉一般倉正式報關，會產生移倉費、倉租費、稅金等等費用(新台幣$4700起)，會實報實銷由派件公司代取，正式報關需要提供委任書、賣方資料(姓名/地址/電話)、下單畫面。
            </v-card>
            <v-card
              v-if="airWeightG1(limitCalcItem)"
              class="red--text ma-2 pa-2"
            >
              空運單件70KG以上包裹需要轉一般倉正式報關，會產生移倉費、倉租費、稅金等等費用(新台幣$4700起)，會實報實銷由派件公司代取，正式報關需要提供委任書、賣方資料(姓名/地址/電話)、下單畫面。
            </v-card>
            <v-card
              v-if="weightLimitSe(limitCalcItem)"
              class="red--text ma-2 pa-2"
            >
              海快單件70KG以上包裹需要轉一般倉正式報關，會產生移倉費、倉租費、稅金等等費用，無法事先預估，會實報實銷由派件公司代取，正式報關需要提供委任書、賣方資料(姓名/地址/電話)、下單畫面。
            </v-card>
            <v-card
              v-else-if="volumeLimitSe(limitCalcItem)"
              class="red--text ma-2 pa-2"
            >
              海快單件物品限制長寬高：180cm*180cm*長不限，重量超過70kg或是尺寸三邊有其中兩邊超過180cm無法通過海關x光機，需要轉一般倉正式報關，時效慢且會產生新台幣3-6千高額雜費，稅金另計，費用為實報實銷。
            </v-card>
            <v-card
              v-else-if="volumeLimitSeBy1210(limitCalcItem)"
              class="red--text ma-2 pa-2"
            >
              上海倉海快單件包裹尺寸 三邊其中兩邊超過110cm 需走一般倉正式報關，建議寄至其他海快倉。
            </v-card>
            <v-card
              v-if="suggestTips(limitCalcItem) === 'UnilateralLimit'"
              class="orange--text ma-2 pa-2"
              flat
            >
              提醒您，該包裹單邊長超過90cm，若合併打包在運輸途中極容易丟失或損壞，故需要單獨打包或與其他單邊長超過90cm的物品合包，巧巧郎關心您～
            </v-card>
            <v-card
              v-if="isLongAndThin(limitCalcItem)"
              class="orange--text ma-2 pa-2"
              flat
            >
              細長件與其他規格包裹合併下單極易折斷或丟失，因此只能與同為細長件的包裹合併打包或單獨打包。
            </v-card>
          </template>
        </template>
      </div>
    </div>
  </dir>
</template>

<script>
import calc from 'calculatorjs'
import HctHatPalletFeeText from '@g/components/Text/HctHatPalletFeeText'
import HctCaiFeeText from '@g/components/Text/HctCaiFeeText'
import {
  computerParcelFee,
  computerSettlementWeight
} from '@g/utils/orderUtils'
import {
  airVolumeG1,
  airWeightG1,
  limitHct,
  volumeLimitAir,
  weightLimitAir,
  volumeLimitSe,
  weightLimitSe,
  singleMaxVolume,
  calcWoodenFeeByLuo,
  volumeLimitCs,
  weightLimitCs,
  volumeLimitTcat,
  weightLimitTcat,
  hctHatPalletFee,
  calcHctCai,
  isLongAndThin,
  suggestTips,
} from '@g/utils/parcelUtils'
import CalcFee from './CalcFee'
import SeFee from './ShippingRate/SeFee.vue'
import AirFee from './ShippingRate/AirFee.vue'
import SeaFee from './ShippingRate/SeaFee.vue'

export default {
  components: {
    CalcFee,
    HctHatPalletFeeText,
    HctCaiFeeText,
    SeFee,
    AirFee,
    SeaFee,
  },
  props: {
    inject: Boolean,
    hideHint: Boolean,
    width: [String],
  },
  data () {
    return {
      tabIndex: '',
      srList: [],
      srid: '',
      computerSettlementWeight,
      computerParcelFee,
      form: {
        weight: '',
        width: '',
        height: '',
        length: '',
      },
      calcForm: {},

      airVolumeG1,
      airWeightG1,
      limitHct,
      volumeLimitAir,
      weightLimitAir,
      volumeLimitSe,
      weightLimitSe,
      singleMaxVolume,
      volumeLimitCs,
      weightLimitCs,
      volumeLimitTcat,
      weightLimitTcat,
      hctHatPalletFee,
      isLongAndThin,
      suggestTips,

      isCalcWoodenFee: true,
      injectTransport: 'se',
    }
  },
  computed: {
    jyWarehouses () {
      return this.$store.state.jyWarehouses
    },
    airSrItem () {
      return this.srList.find(item => item.transport === 'air')
    },
    seSrItem () {
      return this.srList.find(item => item.transport === 'se')
    },
    srItem () {
      return this.srList.find(item => item.srid === this.srid)
    },
    jyChgWeight () {
      return calc(`${this.weight}*1000`)
    },
    hctCaiFee () {
      if (this.hctHatPalletFee(this.limitCalcItem)) {
        return 0
      }
      const cai = calcHctCai(this.limitCalcItem)
      if (cai > 6) {
        return Math.ceil(cai - 6) * 25
      }
      return 0
    },
    parcelsFee () {
      const srItem = this.srItem
      const settlementWeight = this.settlementWeight
      if (srItem.firstWeight > 0 && srItem.addlWeight > 0) {
        if (settlementWeight > 1000) {
          return calc(
            `${computerParcelFee(1000, srItem.fwFee)}+${computerParcelFee(
              settlementWeight - 1000,
              srItem.awFee
            )}`
          )
        } else {
          return computerParcelFee(settlementWeight, srItem.fwFee)
        }
      } else {
        return computerParcelFee(settlementWeight, srItem.fwFee)
      }
    },
    settlementWeight () {
      return computerSettlementWeight(this.jyChgWeight, this.srItem.minWeight, true, this.srItem.transport)
    },
    limitCalcItem () {
      return {
        weight: this.calcForm.weight,
        width: Number(this.calcForm.width) * 10,
        height: Number(this.calcForm.height) * 10,
        length: Number(this.calcForm.length) * 10,
      }
    },
    woodenFee () {
      return calcWoodenFeeByLuo(this.limitCalcItem)
    },
    srTypeList () {
      return this.srList.filter(item => item.addrid !== '1050')
    },
  },
  watch: {},
  async mounted () {
    // 普特貨價格一樣，過濾掉特貨
    const srList = []
    this.$store.state.jyShippingRatesSource.forEach(item => {
      // if (!srList.find(item2 => item2.transport === item.transport && item2.fwFee === item.fwFee)) {
      //   srList.push(item)
      // }
      if (!srList.find(item2 => item2.transport === item.transport)) {
        srList.push(item)
      }
    })
    this.srList = srList
    // this.srList = res.data
    //   .filter(item => !(item.transport === 'air' && item.type === 'twt'))
    //   .filter(item => item.addrid !== this.$store.state.parcel.seVipWhsAddrid)
    this.srid = this.srList[0].srid
  },
  methods: {
    async startCalc () {
      const f = {
        ...this.form,
        weight: calc(`${this.form.weight}*1000`),
        volWeight: 0,
        chgWeight: calc(`${this.form.weight}*1000`),
      }
      if (f.width > 0 && f.height > 0 && f.length > 0) {
        f.volWeight = calc(`${f.width}*${f.height}*${f.length}/6000*1000`)
        if (f.volWeight > f.weight * 3) {
          f.chgWeight = calc(`${f.volWeight}/2`)
        }
      }

      this.calcForm = f

      // const res = await this.$store.dispatch('jyb/shippingRate/calc', {
      //   ...this.form
      // })

      // console.dir(res.data)
    },
  }
}
</script>
<style lang="postcss" scoped>
.inputWrapTr {
  > *:nth-child(1){
    width: 100px;
    border-right: 1px solid rgba(0, 0, 0, 0.2);
    padding: 10px 0;
  }
  > *:nth-child(2){
    border-right: 1px solid rgba(0, 0, 0, 0.2);
    padding: 10px 0;
    flex: 1;
    padding: 0 10px;
  }
  input {
    text-align: center;
    width: 50px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    margin-right: 5px;
    outline: none;
  }
}
.dark input {
  color: #fff;
}
.inject {
  border: 1px solid rgba(0, 0, 0, 0.2);
  .inputWrapTr {
    > *:nth-child(1){
      width: 80px;
    }
     > *:nth-child(2){
       border-right: 0px solid rgba(0, 0, 0, 0.2);
     }
  }
}

.carrierItem {
  border: 1px solid green;
  border-radius: 5px;;
  img {
    vertical-align: middle;
  }
  .canUse {
    color: green;
  }
  &.limit {
    border: 1px solid red;
    .canUse {
      display: none;
    }
  }
}
</style>
